import { useState } from 'react';
import { tenants, detectTenant } from '../config/tenantConfig';

/**
 * Componente de desenvolvimento para trocar entre tenants facilmente
 * Remover ou desabilitar em produção
 */
const TenantSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentTenant] = useState(detectTenant());
  
  // Só mostrar em desenvolvimento
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  const switchTenant = (tenantId) => {
    localStorage.setItem('selectedTenant', tenantId);
    window.location.reload(); // Recarrega para aplicar o novo tenant
  };
  
  return (
    <div className="fixed bottom-20 md:bottom-24 left-4 z-50">
      {/* Botão flutuante */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-wine-gold text-wine-dark rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 flex items-center gap-2"
        title="Trocar Tenant (Dev Mode)"
      >
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
        {isOpen && (
          <span className="text-xs font-medium whitespace-nowrap">
            Tenants
          </span>
        )}
      </button>
      
      {/* Menu de seleção */}
      {isOpen && (
        <div className="absolute bottom-16 left-0 bg-[#1a1625] border-2 border-wine-gold/30 rounded-xl shadow-2xl p-3 min-w-[200px]">
          <div className="mb-2 pb-2 border-b border-wine-gold/20">
            <p className="text-xs text-wine-gold font-medium">
              🔧 Modo Desenvolvimento
            </p>
            <p className="text-[10px] text-gray-400 mt-1">
              Tenant Atual: {currentTenant.name}
            </p>
          </div>
          
          <div className="space-y-1">
            {Object.values(tenants).map((tenant) => (
              <button
                key={tenant.id}
                onClick={() => switchTenant(tenant.id)}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-all duration-200 ${
                  currentTenant.id === tenant.id
                    ? 'bg-wine-gold text-wine-dark font-medium'
                    : 'bg-transparent text-white hover:bg-wine-gold/10'
                }`}
              >
                <div className="flex items-center gap-2">
                  {currentTenant.id === tenant.id && (
                    <svg 
                      width="12" 
                      height="12" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="3"
                    >
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  )}
                  <span>{tenant.name}</span>
                </div>
                {tenant.logo && (
                  <p className="text-[10px] opacity-60 mt-1 ml-4">
                    Com logo personalizada
                  </p>
                )}
              </button>
            ))}
          </div>
          
          <div className="mt-3 pt-2 border-t border-wine-gold/20">
            <button
              onClick={() => {
                localStorage.removeItem('selectedTenant');
                window.location.reload();
              }}
              className="w-full text-xs text-gray-400 hover:text-wine-gold transition-colors duration-200"
            >
              🔄 Resetar para padrão
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TenantSwitcher;
